module.exports = __webpack_public_path__ + "img/Employment_Sharing.2b53f545.svg";